import { METRICS } from '../constants';
import { supportsFetchApi } from '../../utils/support';
import { getWithFetch } from '../../utils/send';

const xCDN = {
  g: 'google',
  a: 'akamai',
};

const loadPixelInfoMonitor = (aggregator) => {
  if (!supportsFetchApi()) {
    return;
  }

  getWithFetch('https://http2.mlstatic.com/cdn/ping.gif')
    .then((res) => {
      if (res.headers.has('x-cdn')) {
        const cdn = res.headers.get('x-cdn');

        aggregator(METRICS.X_CDN, xCDN[cdn]);
      }
    })
    .catch((error) => error);
};

export { loadPixelInfoMonitor };
